var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"solid-btn",attrs:{"href":_vm.lang_en['site-check-rating-url'],"target":"_blank"}},[_c('div',{ref:"bg",staticClass:"bg"}),_c('div',{staticClass:"inner"},[_c('p',[_vm._v(_vm._s(_vm.copy))])])])}
var staticRenderFns = []

export { render, staticRenderFns }